/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
	ID: string;
	String: string;
	Boolean: boolean;
	Int: number;
	Float: number;
}

export interface AssetConfigFilter {
	and?: InputMaybe<Array<AssetConfigFilter>>;
	assetId?: InputMaybe<IdFilter>;
	enabled?: InputMaybe<BooleanFilter>;
	minStakingAmount?: InputMaybe<NumberFilter>;
	name?: InputMaybe<StringFilter>;
	or?: InputMaybe<Array<AssetConfigFilter>>;
	soldout?: InputMaybe<BooleanFilter>;
	symbol?: InputMaybe<StringFilter>;
	yearlyInterest?: InputMaybe<NumberFilter>;
	youOwn?: InputMaybe<BooleanFilter>;
}

export interface AssetConfigOrder {
	order: Order;
	orderBy: AssetOrderingOptions;
}

export interface AssetConfigResponse {
	__typename?: "AssetConfigResponse";
	assets?: Maybe<Array<StakeableAsset>>;
	/** @deprecated use settings query instead */
	enabledForUserCountry?: Maybe<Scalars["Boolean"]>;
	/** @deprecated use settings query instead */
	stakingEnabled?: Maybe<Scalars["Boolean"]>;
}

export enum AssetOrderingOptions {
	Enabled = "enabled",
	MinStakingAmount = "minStakingAmount",
	Name = "name",
	Soldout = "soldout",
	YearlyInterest = "yearlyInterest",
	YouOwn = "youOwn"
}

export interface AutoStaking {
	__typename?: "AutoStaking";
	enabled: Scalars["Boolean"];
}

export interface AutoStakingInput {
	enabled: Scalars["Boolean"];
}

export interface Balance {
	__typename?: "Balance";
	asset: CurrencyAmount;
	fiat: FiatAmount;
}

export interface BooleanEnabled {
	__typename?: "BooleanEnabled";
	enabled: Scalars["Boolean"];
}

export interface BooleanFilter {
	equals: Scalars["Boolean"];
}

/** Value Types */
export interface CurrencyAmount {
	__typename?: "CurrencyAmount";
	value: Scalars["String"];
}

export interface CurrencyAmountInput {
	value: Scalars["String"];
}

export interface DateTime {
	__typename?: "DateTime";
	iso8601: Scalars["String"];
	unixTimestamp: Scalars["Int"];
}

export interface Error {
	__typename?: "Error";
	httpCode: Scalars["String"];
	key: Scalars["String"];
	localizedDisplayMessage: Scalars["String"];
}

/**
 * FailureResponse. Contains both an error object as well as a
 * meta object which will only be delivered if there is actionable information
 * to be communicated.
 *
 * In an Error-Case (such as a 500 Internal Server Error) you will receive the
 * same structure under the "bitpanda" key in the extensions section of the
 * Error response. See https://www.apollographql.com/docs/apollo-server/data/errors/.
 *
 * interface ErrorResponse {
 * error: Error!
 * meta: Any
 * }
 *
 * Note: The above is not an actual GraphQL type but serves to illustrate the format of Error responses.
 */
export interface FailureResponse {
	error: Error;
}

export interface FiatAmount {
	__typename?: "FiatAmount";
	value: Scalars["String"];
}

export interface HealthFailure extends FailureResponse {
	__typename?: "HealthFailure";
	error: Error;
	meta?: Maybe<HealthFailureMeta>;
}

export interface HealthFailureMeta {
	__typename?: "HealthFailureMeta";
	aMetaField?: Maybe<Scalars["String"]>;
}

/** health */
export type HealthResponse = HealthFailure | HealthSuccess;

export interface HealthSuccess {
	__typename?: "HealthSuccess";
	code: Scalars["String"];
}

export interface IdFilter {
	equals: Scalars["ID"];
}

export enum LeveragedTokenType {
	Long = "LONG",
	Short = "SHORT"
}

/** Please provide one of the two types of IDs. Providing both will lead to a BadRequest. */
export interface LeveragedTokenTypeInput {
	assetId: Scalars["ID"];
}

export interface LifetimeRewards {
	__typename?: "LifetimeRewards";
	asset: StakeableAsset;
	rewardsAmount: Balance;
}

export interface LifetimeRewardsFilter {
	assetId?: InputMaybe<IdFilter>;
}

export interface Mutation {
	__typename?: "Mutation";
	settingsUpdate: SettingsUpdateResponse;
	stake: StakingResponse;
	unstake: StakingResponse;
}

export interface MutationSettingsUpdateArgs {
	input: UpdateSettingActionInput;
}

export interface MutationStakeArgs {
	input: StakingActionInput;
}

export interface MutationUnstakeArgs {
	input: StakingActionInput;
}

export interface NumberFilter {
	equals?: InputMaybe<Scalars["Float"]>;
	gt?: InputMaybe<Scalars["Float"]>;
	gte?: InputMaybe<Scalars["Float"]>;
	lt?: InputMaybe<Scalars["Float"]>;
	lte?: InputMaybe<Scalars["Float"]>;
}

export enum Order {
	Asc = "ASC",
	Desc = "DESC"
}

export interface Query {
	__typename?: "Query";
	assetConfig: AssetConfigResponse;
	balances: Array<StakingBalance>;
	hasHistory: Scalars["Boolean"];
	health: HealthResponse;
	history: Array<StakingAction>;
	integrationThrow: Scalars["Boolean"];
	leveragedTokenType: LeveragedTokenType;
	lifetimeRewards: Array<LifetimeRewards>;
	settings: Settings;
	statistics: StatisticsResponse;
}

export interface QueryAssetConfigArgs {
	filter?: InputMaybe<AssetConfigFilter>;
	order?: InputMaybe<Array<AssetConfigOrder>>;
}

export interface QueryHistoryArgs {
	filter?: InputMaybe<StakingHistoryFilter>;
	order?: InputMaybe<Array<InputMaybe<StakingHistoryOrder>>>;
}

export interface QueryLeveragedTokenTypeArgs {
	input: LeveragedTokenTypeInput;
}

export interface QueryLifetimeRewardsArgs {
	filter?: InputMaybe<LifetimeRewardsFilter>;
}

export interface RewardsAmount {
	__typename?: "RewardsAmount";
	totalCurrent: Balance;
	totalLastMonth: Balance;
}

/** Settings Query */
export interface Settings {
	__typename?: "Settings";
	autoStake: AutoStaking;
	userJourneys: UserJourneys;
}

export interface SettingsUpdateResponse {
	__typename?: "SettingsUpdateResponse";
	autoStake: Scalars["Boolean"];
}

export interface StakeableAsset {
	__typename?: "StakeableAsset";
	assetId: Scalars["ID"];
	/**
	 * Allowed values: ENABLED | SOLD_OUT | DISABLED
	 * Could be extended in the future.
	 */
	availability: Scalars["String"];
	isAutoStakingEnabled: Scalars["Boolean"];
	/** @deprecated No longer supported */
	isLocked: Scalars["Boolean"];
	minStakingAmount: CurrencyAmount;
	nextReward: DateTime;
	rewardIntervalInDays: Scalars["Int"];
	stakingMode: StakingMode;
	/** Allowed values: flexible | locked */
	stakingType: StakingType;
	unboundPeriod?: Maybe<Scalars["Int"]>;
	yearlyInterest: Scalars["Float"];
}

export interface StakingAction {
	__typename?: "StakingAction";
	asset: StakeableAsset;
	assetAmount: CurrencyAmount;
	balanceAfter: CurrencyAmount;
	createdAt: DateTime;
	fiatAmount?: Maybe<CurrencyAmount>;
	/** Will be set only on stake mutation, will be null otherwise. */
	firstRewardPayoutAt?: Maybe<DateTime>;
	id: Scalars["ID"];
	/** Will be set only for locked staking type, will be null otherwise. */
	releaseTimestamp?: Maybe<DateTime>;
	status?: Maybe<StakingStatusType>;
	tax?: Maybe<Tax>;
	type: StakingActionType;
	/** The wallet affected by the staking action. */
	walletId?: Maybe<Scalars["ID"]>;
}

/** Empty Object. Boolean only exists to satisfy requirement. See https://github.com/graphql/graphql-spec/issues/568 */
export interface StakingActionInProgress {
	__typename?: "StakingActionInProgress";
	_?: Maybe<Scalars["Boolean"]>;
}

export interface StakingActionInput {
	assetAmount: CurrencyAmountInput;
	assetId: Scalars["ID"];
	/** The staking action type allowed values: stake | unstake | reward */
	stakingType?: InputMaybe<StringTypeFilter>;
	/** Allowed values: flexible | locked */
	type?: InputMaybe<StakingType>;
	/** The wallet affected by the staking action. */
	walletId?: InputMaybe<Scalars["ID"]>;
}

/** Domain Types */
export enum StakingActionType {
	Reward = "REWARD",
	Stake = "STAKE",
	Unstake = "UNSTAKE"
}

export interface StakingBalance {
	__typename?: "StakingBalance";
	asset: StakeableAsset;
	rewardsAmount: RewardsAmount;
	/** @deprecated Use totalStakedAmount.asset instead of this */
	stakedAmount: CurrencyAmount;
	totalStakedAmount: Balance;
}

export interface StakingHistoryFilter {
	asset?: InputMaybe<IdFilter>;
	stakingType?: InputMaybe<StringTypeFilter>;
	status?: InputMaybe<StakingStatusType>;
	type?: InputMaybe<StringFilter>;
}

export enum StakingHistoryOptions {
	ReleaseTimestamp = "releaseTimestamp"
}

export interface StakingHistoryOrder {
	order: Order;
	orderBy: StakingHistoryOptions;
}

export enum StakingMode {
	Earn = "earn",
	Stake = "stake"
}

/** Response Types */
export type StakingResponse = StakingAction | StakingActionInProgress;

export enum StakingStatusType {
	Failed = "FAILED",
	Pending = "PENDING",
	Released = "RELEASED"
}

/** Staking Types */
export enum StakingType {
	Flexible = "flexible",
	Locked = "locked"
}

export interface StatisticsResponse {
	__typename?: "StatisticsResponse";
	nonStakedAssetsCount: Scalars["Int"];
}

export interface StringFilter {
	contains?: InputMaybe<Scalars["String"]>;
	equals?: InputMaybe<Scalars["String"]>;
}

export interface StringTypeFilter {
	contains?: InputMaybe<Scalars["String"]>;
	equals?: InputMaybe<Scalars["String"]>;
}

export interface Tax {
	__typename?: "Tax";
	assetAmount: CurrencyAmount;
	fiatAmount: CurrencyAmount;
	fiatId: Scalars["Int"];
}

/** Settings Update Mutation */
export interface UpdateSettingActionInput {
	autoStaking: AutoStakingInput;
}

export interface UserJourneys {
	__typename?: "UserJourneys";
	autoStaking: Array<Scalars["String"]>;
	earnOnStableCoin: Array<Scalars["String"]>;
	earning: Array<Scalars["String"]>;
	earningLocked: Array<Scalars["String"]>;
	releasing: Array<Scalars["String"]>;
	releasingLocked: Array<Scalars["String"]>;
	staking: Array<Scalars["String"]>;
	stakingLocked: Array<Scalars["String"]>;
	unstaking: Array<Scalars["String"]>;
	unstakingLocked: Array<Scalars["String"]>;
}
